// Support legacy charts that are not in the new format
export const extractEChartJsonFromProps = (props) => {
  const { config, children } = props;

  if (config) {
    try {
      return [JSON.parse(config)];
    } catch (e) {
      return [];
    }
  }

  try {
    const originalJSONText =
      children
        // @ts-expect-error
        ?.map((c) => c.data)
        ?.filter(Boolean)
        ?.join("") || "{}";

    // Handle where the LLM returns multiple graphs in the same block
    let jsonText = originalJSONText
      .replaceAll(/}[\s,]*{/g, "},{")
      .replaceAll("\n", "");

    if (!jsonText.startsWith("[")) {
      jsonText = `[${jsonText}`;
    }
    if (!jsonText.endsWith("]")) {
      jsonText = `${jsonText}]`;
    }

    const jsons = JSON.parse(jsonText);

    return jsons.map((spec) => ({ ...spec, title: undefined }));
  } catch (e) {
    return [];
  }
};
